import { GSearchField } from '~/presentation/ui';
import { useTranslation } from 'react-i18next';
import { useRef, useEffect } from 'react';

interface SearchFieldProps {
  queryValue: string;
  onSearch: (value: string) => void;
  searchPlaceholder?: string;
}

export const SearchField: React.FC<SearchFieldProps> = ({
  queryValue,
  onSearch,
  searchPlaceholder,
}) => {
  const { t } = useTranslation();
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    requestAnimationFrame(() => {
      const input = wrapperRef.current?.querySelector('input');
      input?.focus();
    });
    return () => {
      onSearch('');
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div ref={wrapperRef}>
      <GSearchField
        searchValue={queryValue}
        isLoading={false}
        searchPlaceholder={searchPlaceholder || t('Search')}
        onSearch={onSearch}
        size="medium"
      />
    </div>
  );
};
